import { render } from "./Cod5Page.vue?vue&type=template&id=9bac1eb8&scoped=true"
import script from "./Cod5Page.vue?vue&type=script&lang=js"
export * from "./Cod5Page.vue?vue&type=script&lang=js"

import "./Cod5Page.vue?vue&type=style&index=0&id=9bac1eb8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9bac1eb8"]])

export default __exports__